import { z } from 'zod'
import { getEndpoint } from '@/ui/core/config'
import { EventCategory, GuestbookEvent } from '@/shared/types'
import { GuestbookClient } from '../GuestbookClient'

export interface CreateEventInput {
  title: string
  date: string
  category: EventCategory
  isFeedPublic: boolean
}

type NewEventInput = Omit<GuestbookEvent, 'id' | 'createdAt' | 'updatedAt'>

/**
 *
 * @param this The instance of Guestbook
 * @param input The parameters to create an event.
 * @returns
 */
export async function createEvent(
  this: GuestbookClient,
  input: CreateEventInput,
): Promise<string> {
  const jwtToken = (await this.auth.getJWT()) ?? ''
  const owner = await this.auth.getUser()

  const { ...props } = input

  const newEvent: NewEventInput = {
    ...props,
    owner,
    images: [],
  }
  const result = await fetch(getEndpoint('events'), {
    method: 'POST',
    body: JSON.stringify(newEvent),
    headers: {
      Authorization: jwtToken,
    },
  })
  const response = z.object({ id: z.string() }).parse(await result.json())
  return response.id
}
